export interface FulfillmentWindow {
  id: string;
  label: string;
  startTime: string;
  endTime: string;
}

/** Shared collection and delivery windows (Tuesday–Sunday). */
export const FULFILLMENT_WINDOWS: FulfillmentWindow[] = [
  { id: '12-13', label: '12pm - 1pm', startTime: '12:00 PM', endTime: '1:00 PM' },
  { id: '13-15', label: '1pm - 3pm', startTime: '1:00 PM', endTime: '3:00 PM' },
  { id: '15-17', label: '3pm - 5pm', startTime: '3:00 PM', endTime: '5:00 PM' }
];

export const getFulfillmentWindowById = (id: string): FulfillmentWindow | undefined =>
  FULFILLMENT_WINDOWS.find((window) => window.id === id);

export const formatFulfillmentWindow = (
  startTime?: string,
  endTime?: string
): string => {
  if (!startTime || !endTime) return '';
  const match = FULFILLMENT_WINDOWS.find(
    (window) => window.startTime === startTime && window.endTime === endTime
  );
  return match ? match.label : `${startTime} - ${endTime}`;
};

export const getOrderFulfillmentTimes = (order: {
  deliveryOption: 'collection' | 'delivery';
  collectionStartTime?: string;
  collectionEndTime?: string;
  deliveryStartTime?: string;
  deliveryEndTime?: string;
}): { startTime?: string; endTime?: string } => {
  if (order.deliveryOption === 'delivery') {
    return { startTime: order.deliveryStartTime, endTime: order.deliveryEndTime };
  }
  return { startTime: order.collectionStartTime, endTime: order.collectionEndTime };
};
